import { NUMBERS } from './Common';

const SWING_CONTRACT_GENESIS_URL = '/api/Contract';

export const GET_TERMINAL_MAPPINGS = (isValid: boolean) =>
  `${SWING_CONTRACT_GENESIS_URL}/GetAllSwingContractMappings?isValid=${isValid}`;
export const DOWNLOAD_TERMINAL_MAPPINGS = `${SWING_CONTRACT_GENESIS_URL}/DownloadSwingContractMappingsInExcel`;
export const ADD_UPDATE_SWING_CONTRACT = `${SWING_CONTRACT_GENESIS_URL}/AddOrUpdateSwingContractMapping`;
export const GET_SWING_CONTRACT_MAPPING_DATA_BY_ID = `${SWING_CONTRACT_GENESIS_URL}/GetSwingContractMappingDataById`;
export const GET_ALL_CONTRACT_NAMES = `${SWING_CONTRACT_GENESIS_URL}/GetAllContractNames`;
export const CLONE_SWING_CONTRACT = `${SWING_CONTRACT_GENESIS_URL}/CloneSwingContract`;
export const UPDATE_MANUAL_ENERGY = `${SWING_CONTRACT_GENESIS_URL}/UpdateSwingContract`;
export const GET_ALL_SWING_CONTRACTS = `${SWING_CONTRACT_GENESIS_URL}/GetAllSwingContracts`;
export const GET_ALL_SWING_CONTRACT_TYPE = `${SWING_CONTRACT_GENESIS_URL}/GetAllSwingContractType`;
export const DELETE_SWING_CONTRACT_MAPPING = `${SWING_CONTRACT_GENESIS_URL}/DeleteSwingContractMapping`;
export const GET_SWING_CONTRACT_MAPPING_AUDIT_LOG_INFO = `${SWING_CONTRACT_GENESIS_URL}/GetSwingContractMappingAuditLogInfo`;
export const GET_SWING_CONTRACT_AUDIT_LOG_INFO = `${SWING_CONTRACT_GENESIS_URL}/GetSwingContractAuditLogInfo`;
export const GET_SWING_CONTRACT_PAYLOAD_INFO = `${SWING_CONTRACT_GENESIS_URL}/GetSwingContractPayloadInfo`;
export const DOWNLOAD_SWING_CONTRACTS_EXCEL = `${SWING_CONTRACT_GENESIS_URL}/DownloadSwingContractsExcel`;
export const UPLOAD_TO_ENDUR_SWING_CONTRACT = `${SWING_CONTRACT_GENESIS_URL}/UploadToEndur`;
export const UPLOAD_TO_ALIGNE_SWING_CONTRACT = `${SWING_CONTRACT_GENESIS_URL}/UploadSwingContractsDataToAligne`;
export const GET_CURRENT_ALIGNE = `${SWING_CONTRACT_GENESIS_URL}/LoadSwingContractAligneVolumeDataInDb`;

export const SWING_CONTRACT_MESSAGES = {
  SERVER_ERROR: 'Something went wrong please contact system administrator.',
  REQUIRED_SOURCE: 'Source is required',
  REQUIRED_ZKEY: 'ZKey is required',
  REQUIRED_DESTINATION: 'Destination is required',
  REQUIRED_DEAL_UNIT: 'Deal Unit is required',
  REQUIRED_ENERGY: 'Energy is required',
  REQUIRED_DEAL_LEG_ID: 'Deal ID is required',
  REQUIRED_UNIT: 'Unit is required',
  REQUIRED_DESCRIPTION: 'Description is required',
  REQUIRED_CONTRACT_NAME: 'Contract Name is required',
  REQUIRED_GAS_DAY: 'Gas Day is required',
  WD_DA_VARIANCE_RANGE: 'Value must be between 0 and 100',
  REQUIRED_ENTRY_OR_EXIT: 'Entry or Exit is required',
  SOMETHING_WENT_WRONG:
    "Something wen't wrong, Please try after sometime or Refresh the page.",
  REQUIRED_GAS_DAY_RANGE: 'Gas Day Range is required',
  FAILED_FETCH_CONTRACT_NAMES: 'Failed to fetch contract names',
  FAILED_FETCH_SWING_CONTRACT_MAPPINGS:
    'Failed to fetch swing contract mappings',
  FAILED_FETCH_CONTRACT_MAPPING_DATA: 'Failed to fetch contract mapping data',
  FAILED_FETCH_SWING_CONTRACT_TYPES: 'Failed to fetch swing contract types',
  INVALID_DEAL_LEG_ID:
    'Deal ID format is invalid. It should be in the format digits_digits (e.g. 123_4)',
};

export const convertEnergyValue = (
  value: number | null,
  toUnit: string
): string => {
  if (value === null) {
    return '0';
  }

  switch (toUnit) {
    case 'TJ':
      return (value * NUMBERS.MWH_TJ_CONVERSION).toFixed(NUMBERS.FIVE); // MWh to TJ conversion
    case 'GWh':
      return (value / NUMBERS.THOUSAND).toFixed(NUMBERS.FIVE); // MWh to GWh conversion
    case 'KWh':
      return (value * NUMBERS.THOUSAND).toFixed(NUMBERS.FIVE); // MWh to KWh conversion
    case 'Therms':
      return (value / NUMBERS.THERMS_MWh_CONVERSION).toFixed(NUMBERS.FIVE); // MWh to Therms conversion
    default:
      return value.toFixed(NUMBERS.FIVE); // No conversion, just format
  }
};

export const renderPersistedEnergy = (value: number | null, toUnit: string) => {
  if (value === null || value === undefined) {
    return '-';
  }
  switch (toUnit) {
    case 'GWh':
      // KWh to GWh
      if (value === 0) {
        return 0;
      }
      return (value / NUMBERS.THOUSAND / NUMBERS.THOUSAND).toLocaleString(
        'en-US',
        {
          minimumFractionDigits: NUMBERS.FIVE,
        }
      );
    case 'KWh':
      // MWh to KWh
      if (value === 0) {
        return 0;
      }
      return Math.round(value * NUMBERS.ONE).toLocaleString('en-US');
    case 'Therms':
      // MWh to Therms
      if (value === 0) {
        return 0;
      }
      return Math.round(
        value / NUMBERS.THERMS_MWh_CONVERSION / NUMBERS.THOUSAND
      ).toLocaleString('en-US');
    default:
      // MWh to TJ
      if (value === 0) {
        return 0;
      }
      return (
        (value * NUMBERS.MWH_TJ_CONVERSION) /
        NUMBERS.THOUSAND
      ).toLocaleString('en-US', {
        minimumFractionDigits: NUMBERS.FIVE,
      });
  }
};

export const renderEnergy = (value: number | null, toUnit: string) => {
  if (value === null || value === undefined) {
    return '-';
  }
  switch (toUnit) {
    case 'GWh':
      // MWh to GWh
      if (value === 0) {
        return 0;
      }
      return (value / NUMBERS.THOUSAND).toLocaleString('en-US', {
        minimumFractionDigits: NUMBERS.FIVE,
      });
    case 'KWh':
      // MWh to KWh
      if (value === 0) {
        return 0;
      }
      return Math.round(value * NUMBERS.THOUSAND).toLocaleString('en-US');
    case 'Therms':
      // MWh to Therms
      if (value === 0) {
        return 0;
      }
      return Math.round(value / NUMBERS.THERMS_MWh_CONVERSION).toLocaleString(
        'en-US'
      );
    default:
      // MWh to TJ
      if (value === 0) {
        return 0;
      }
      return (value * NUMBERS.MWH_TJ_CONVERSION).toLocaleString('en-US', {
        minimumFractionDigits: NUMBERS.FIVE,
      });
  }
};

export const convertToMWh = (
  value: number | null,
  fromUnit: string
): number | null => {
  if (value === null) {
    return null;
  }

  switch (fromUnit) {
    case 'TJ':
      return (value * NUMBERS.THOUSAND) / NUMBERS.THREE_POINT_SIX; // TJ to MWh conversion
    case 'GWh':
      return value * NUMBERS.THOUSAND; // GWh to MWh conversion
    case 'KWh':
      return value / NUMBERS.THOUSAND; // KWh to MWh conversion
    case 'Therms':
      return value / NUMBERS.THERMAL_CONVERSION_FACTOR; // Therms to MWh conversion
    default:
      return value; // Already in MWh
  }
};

export const UNIT_MAPPING = [
  {
    id: 'Therms',
    name: 'Therms',
  },
  {
    id: 'MWh',
    name: 'MWh',
  },
  {
    id: 'GWh',
    name: 'GWh',
  },
  {
    id: 'KWh',
    name: 'KWh',
  },
  { id: 'TJ', name: 'TJ' },
];

export const SWING_CONTRACT_SOURCES = [
  {
    id: 'Email',
    name: 'Email',
    isActive: true,
  },
  {
    id: 'Aligne',
    name: 'Aligne',
    isActive: true,
  },
];

export const SWING_CONTRACT_DESTINATIONS = [
  { id: 'Endur', name: 'Endur', isActive: true },
  { id: 'Aligne', name: 'Aligne', isActive: true },
];

export const DEAL_UNIT_ENUM = [
  { id: 'kWh', name: 'kWh' },
  { id: 'Therms', name: 'Therms' },
];
